import { describeEmailFlags } from "../../js/api/messaging/emailOutbox";

export default function EmailFlagsNote({ flags }) {
  if (!flags) return null;
  return <p className="email-flags-note">{describeEmailFlags(flags)}</p>;
}
